<div
  class="mx-8 my-20 max-w-[1064px]"
  animate.enter="ease-in-fast"
  *transloco="let t"
>
  <div class="flex flex-col justify-between gap-10">
    <div class="flex flex-col gap-2">
      <h1 class="text-3xl font-semibold">
        {{ t('portal.courseSettings.courseSettingsHeadline') }}
      </h1>
      <h1 class="max-w-[1064px] text-base text-grey">
        {{ t('portal.courseSettings.subtitle') }}
      </h1>
    </div>
    <div class="flex flex-col gap-4">
      <mat-expansion-panel
        [expanded]="true"
        class="expansion-panel-arrow-color"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h2 class="text-2xl font-semibold">
              {{ t('portal.courseSettings.generalSettings.headline') }}
            </h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div
          class="flex max-w-[1064px] flex-row place-items-stretch justify-between gap-4 overflow-x-hidden max-[1444px]:flex-wrap"
        >
          <div
            class="flex w-full max-w-[620px] flex-1 flex-col justify-center gap-6 rounded-xl border border-grey-lightGrey bg-white p-8"
          >
            <div class="flex max-w-[556px] flex-1 flex-col">
              <div class="flex h-8 justify-between">
                <span class="font-semibold">{{
                  t('portal.courseSettings.generalSettings.companyLogo')
                }}</span>
                @if (
                  this.accentColor !== this.defaultAccentColor ||
                  companyLogoUrl !== defaultLogoUrl
                ) {
                  <app-reset-text-button
                    (resetClick)="onResetToDefault()"
                  ></app-reset-text-button>
                }
              </div>
              <div
                class="flex max-w-[556px] flex-1 gap-4 max-lg:flex-wrap lg:justify-between"
              >
                <div
                  class="relative flex size-[108px] shrink-0 place-content-center rounded-md border border-grey-lightGrey bg-grey-veryLightGrey p-4"
                >
                  <img
                    [src]="companyLogoUrl"
                    alt="Company Logo"
                    class="max-h-full max-w-full object-contain"
                  />
                  @if (companyLogoUrl !== defaultLogoUrl) {
                    <button
                      type="button"
                      (click)="resetLogoToDefault()"
                      class="absolute right-1 top-1 z-10 flex size-6 items-center justify-center rounded-full bg-white text-grey transition-colors hover:bg-grey-lightGrey hover:text-black"
                      mat-icon-button
                      aria-label="Remove logo"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </div>
                <app-file-upload
                  #logoUpload
                  [acceptedFile]="'image/png'"
                  class="size-full"
                  [icon]="'upload'"
                  sizeClasses="w-full min-w-[290px] max-w-[436px] h-full max-h-[108px] flex-shrink-0 py-4 px-6"
                  (fileSelected)="onLogoSelected($event)"
                  >{{
                    t('portal.courseSettings.generalSettings.logoFormat')
                  }}</app-file-upload
                >
              </div>
            </div>
            <div class="flex max-w-[556px] flex-col">
              <div class="flex">
                <span class="font-semibold">{{
                  t('portal.courseSettings.generalSettings.accentColor')
                }}</span>
              </div>
              <div
                class="flex items-center gap-4 max-lg:flex-col max-lg:justify-start"
              >
                <app-color-picker
                  [tooltip]="
                    t(
                      'portal.courseSettings.generalSettings.colorPickerTooltip'
                    )
                  "
                  [color]="accentColor"
                  (colorChange)="onAccentColorChange($event)"
                ></app-color-picker>
                <app-primary-button
                  class="ml-auto flex max-lg:mx-auto max-lg:inline-flex"
                  [text]="
                    t('portal.courseSettings.generalSettings.saveButton', {
                      count: pendingChangesCount,
                    })
                  "
                  [disabled]="!hasPendingChanges"
                  (buttonClicked)="saveGeneralSettings()"
                ></app-primary-button>
              </div>
            </div>
          </div>
          <div
            class="flex h-[308px] w-[428px] justify-center gap-6 rounded-xl border border-grey-lightGrey bg-grey-veryLightGrey p-8"
          >
            <div class="flex flex-col">
              <div class="flex justify-start">
                <mat-icon
                  class="material-icons-outlined !inline-flex place-content-center text-sm text-grey"
                >
                  info
                </mat-icon>
                <span class="text-sm">{{
                  t('portal.courseSettings.generalSettings.livePreview')
                }}</span>
              </div>
              <p class="text-xs">
                {{
                  t('portal.courseSettings.generalSettings.previewExplanation')
                }}
              </p>
              <div class="relative pt-1">
                <img src="assets/example.png" alt="Example Slide" />
                <div class="absolute left-[4.93%] top-[12.2%]">
                  <img
                    [src]="companyLogoUrl"
                    [style]="logoImgStyle"
                    alt="Company Logo"
                  />
                </div>
                <div
                  class="absolute left-[4.93%] top-[46.4%] h-[1.5%] w-[4.7%] rounded-md"
                  [style.background-color]="accentColor"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
    <div class="flex flex-col gap-4">
      <h2 class="text-2xl font-semibold">
        {{ t('portal.courseSettings.topicAreaSettings.headline') }}
      </h2>
      <mat-tab-group
        [selectedIndex]="selectedTabIndex"
        (selectedIndexChange)="onTabChange($event)"
        class="remove-border-bottom w-[1065px]"
      >
        @for (tab of tabs; track tab) {
          <mat-tab class="flex" [disabled]="tab.isLocked">
            <ng-template mat-tab-label>
              <mat-icon
                class="material-icons mr-2 !inline-flex place-content-center text-base"
                [class.opacity-40]="tab.isLocked"
              >
                {{ tab.icon }}
              </mat-icon>
              <span [class.opacity-40]="tab.isLocked">
                {{
                  t(
                    'portal.courseSettings.topicAreaSettings.topicAreas.' +
                      tab.key
                  )
                }}
              </span>
              @if (tab.isLocked) {
                <div
                  class="pointer-events-auto z-[5] ml-2 cursor-pointer"
                  [matTooltip]="
                    t('portal.courseLibrary.lockedTooltip', {
                      topicArea: t('portal.topicAreas.' + tab.key),
                    })
                  "
                  matTooltipPosition="above"
                >
                  <mat-icon
                    class="material-icons text-dark-grey place-content-center text-base"
                    >lock</mat-icon
                  >
                </div>
              }
            </ng-template>
            <div class="mt-5 mb-2 {{ tab?.wrapperClass }}">
              <ng-container
                [ngComponentOutlet]="tab.component"
                [ngComponentOutletInputs]="{
                  icon: tab.icon,
                  headline: tab.key,
                }"
              />
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
</div>
@if (courseVariablesService.variablesChanged()) {
  <app-saving-banner class="relative w-full"> </app-saving-banner>
}
